import { useCallback, useMemo, useState } from "react";

import { DateTimePicker } from "@mui/x-date-pickers";
import debounce from "@mui/utils/debounce";

import { DateTime } from "luxon";

export interface PlaybackRangeDateTimePickerProps {
    label: string;
    value: DateTime;
    error?: string;
    onChange: (dateTime: DateTime | null) => void;
}

export function PlaybackRangeDateTimePicker(
    props: PlaybackRangeDateTimePickerProps,
) {
    const debouncedOnChange = useMemo(
        () => debounce(props.onChange, 500),
        [props.onChange],
    );

    const [isDateTimePickerOpen, setIsDateTimePickerOpen] = useState(false);

    const onChangeDateTime = useCallback(
        (value: DateTime | null) =>
            !isDateTimePickerOpen && debouncedOnChange(value),
        [debouncedOnChange, isDateTimePickerOpen],
    );

    return (
        <DateTimePicker
            label={props.label}
            defaultValue={props.value}
            views={["year", "month", "day", "hours", "minutes"]}
            disableFuture
            sx={{
                paddingBottom: 3,
            }}
            onOpen={() => setIsDateTimePickerOpen(true)}
            onClose={() => setIsDateTimePickerOpen(false)}
            onChange={onChangeDateTime}
            onAccept={(value) => debouncedOnChange(value)}
            slotProps={{
                textField: {
                    helperText: props.error,
                    error: !!props.error,
                },
            }}
        />
    );
}
